/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Tab_PlayersInputs */



/**
* | output |
* | --- |
* | "Players" |
*
* @param {Tournament_Tab_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_tab_players = /** @type {((inputs?: Tournament_Tab_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Tab_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Joueurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Jugadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogadores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giocatori")
	return /** @type {LocalizedString} */ ("Players")
});